package com.dotdrives.web.ui

import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

external interface DotSkeletonProps : Props {
    var width: String?
    var height: String?
    var circle: Boolean?
    var className: String?
}

val DotSkeleton = FC<DotSkeletonProps> { props ->
    val skeletonStyle = js("({})")
    skeletonStyle.width = props.width ?: "100%"
    skeletonStyle.height = props.height ?: "16px"
    if (props.circle == true) {
        skeletonStyle.borderRadius = "50%"
    }

    div {
        className = ClassName(listOfNotNull("dot-skeleton", props.className).joinToString(" "))
        style = skeletonStyle
        ariaHidden = true
    }
}
